
  <h2 mat-dialog-title>    
     Error
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="mat-typography">
     {{errorStatement}} 
  </mat-dialog-content>

  <!-- <mat-dialog-actions class="dialog-actions">
    <button mat-button (click)="close()">Cancel</button>      
  </mat-dialog-actions> -->

